<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="flex justify-content-center mt-3" *ngIf="loadingProfissional">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<div *ngIf="messagemVisivel" class="w-auto mb-5">
					<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
				</div>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="profissional && !loadingProfissional">
						<div class="col-12">
							<div class="grid card-simple">

								<div class="col-12 md:col-2">
									<label class="label-superior">CPF</label>
									<label class="label-inferior" id="cpf">{{ profissional.cpf | cpfPipe }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Nome Completo</label>
									<label class="label-inferior" id="nome">{{ profissional.usuario?.nome }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Apelido</label>
									<label class="label-inferior" id="apelido">{{ profissional.nomeProfissional }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Função</label>
									<label class="label-inferior" id="funcao">{{ profissional.funcao }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">E-mail</label>
									<label class="label-inferior" id="fonePessoal">{{ profissional.usuario?.email }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Fone Pessoal</label>
									<label class="label-inferior" id="fonePessoal">{{ profissional.usuario?.whatsapp | telefoneFormat }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Fone Profissional</label>
									<label class="label-inferior" id="telefone">{{ profissional.telefone | telefoneFormat }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Tipo</label>
									<label class="label-inferior" id="tipo">{{ profissional.tipo }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Contrato</label>
									<label class="label-inferior" id="contrato">{{ profissional.contrato?.razaoSocial }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Agenda</label>
									<label class="label-inferior" id="agenda">
										<label class="product-badge status-instock" id="agenda" *ngIf="profissional.agenda">SIM</label>
										<label class="product-badge status-outofstock" id="agenda" *ngIf="!profissional.agenda">NÃO</label>
									</label>
								</div>
								<div class="col-12 md:col-1">
									<label class="label-superior">Status</label>
									<div class="label-inferior">
										<label class="product-badge status-instock" id="status" *ngIf="profissional.ativo">ATIVO</label>
										<label class="product-badge status-outofstock" id="status" *ngIf="!profissional.ativo">INATIVO</label>
									</div>
								</div>
							</div>
						</div>

						<div class="w-full">
							<p-table #dt1 [value]="habilidades" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="header">
									<tr>
										<th>
											<div>
												Serviço
											</div>
										</th>
										<th>
											<div>
												Rateio
											</div>
										</th>
										<th>
											<div>
												Comissão
											</div>
										</th>
										<th>
											<div>
												Valor Fixo
											</div>
										</th>
										<th>
											<div>
												Tempo (HH:mm)
											</div>
										</th>
										<th>
											<div>
												Agenda
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item let-i="rowIndex">
									<tr>
										<td>
											<label>{{ item.itemServico.descricao }}</label>
										</td>
										<td>
											<label>{{ (item.rateio ?? 0) / 100 | percent:'1.2-2' }}</label>
										</td>
										<td>
											<label>{{ (item.comissao ?? 0) / 100 | percent:'1.2-2' }}</label>
										</td>
										<td>
											<label>{{ item.valorFixo | currency:'BRL' }}</label>
										</td>
										<td>
											<label>{{ item.tempoMedio }}</label>
										</td>
										<td>
											<label>{{ item.itemServico.agenda }}</label>
										</td>
		
										
									</tr>
								</ng-template>
								<ng-template pTemplate="summary">
									<div class="flex align-items-center justify-content-between">
										Há {{habilidades ? habilidades.length : 0 }} habilidades cadastradas.
									</div>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro cadastrado.</td>
									</tr>
								</ng-template>
							</p-table>

						</div>

					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loadingProfissional">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem mt-5" routerLink="/apps/profissional"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>